<template>
  <div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="col-md-12 col-sm-12 col-xs-12 h-100">
        <h5 class="col-md-12 col-sm-12 col-xs-12">THÔNG TIN SỐ</h5>
        <div class="form-group col-md-3 col-sm-6 col-xs-12" v-bind:class="errorPhoneNumber ? 'has-error' : ''">
          <label>SĐT<span class="error-symbol"></span></label>
          <input type="text" class="form-control" v-model="phoneNumberDetail.phone_number"
                 placeholder="Nhập số điện thoại..." :disabled="phoneNumberDetail.id || isTechnicalStaff"/>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12"
             v-bind:class="errorPhoneNumberPickedDate ? 'has-error' : ''">
          <label>Ngày Lấy<span class="error-symbol"></span></label>
          <date-picker v-model="phoneNumberDetail.pickup_date" valueType="format" :disabled="isTechnicalStaff"></date-picker>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12" v-bind:class="errorPhoneNumberProvider ? 'has-error' : ''">
          <label>NCC<span class="error-symbol"></span></label>
          <multiselect v-model="phoneNumberDetail.provider" :options="providerList" :multiple="false"
                       :close-on-select="true"
                       placeholder="Vui lòng chọn" label="text" track-by="value" :disabled="isTechnicalStaff"></multiselect>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12" v-bind:class="errorPhoneNumberMain ? 'has-error' : ''">
          <label>Số chủ<span class="error-symbol"></span></label>
          <multiselect v-model="phoneNumberDetail.main_phone_number" :options="mainPhoneNumberList" :multiple="false"
                       :close-on-select="true"
                       placeholder="Vui lòng chọn" label="text" track-by="value" :disabled="isTechnicalStaff"></multiselect>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12">
          <label>Ngày Khách Lấy</label>
          <date-picker v-model="phoneNumberDetail.client_use_date" valueType="format" :disabled="isTechnicalStaff"></date-picker>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12" v-bind:class="errorPhoneNumberLegal ? 'has-error' : ''">
          <label>Pháp nhân<span class="error-symbol"></span></label>
          <multiselect v-model="phoneNumberDetail.legal" :options="legalList" :multiple="false"
                       :close-on-select="true"
                       placeholder="Vui lòng chọn" label="text" track-by="value" :disabled="isTechnicalStaff"></multiselect>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12" v-bind:class="errorPhoneNumberStatus ? 'has-error' : ''">
          <label>Trạng thái số<span class="error-symbol"></span></label>
          <multiselect v-model="phoneNumberDetail.phone_number_status" :options="internalMoveStatusList" :multiple="false"
                       :close-on-select="true" @select="onStatusSelect($event)"
                       placeholder="Vui lòng chọn" label="text" track-by="value"></multiselect>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12">
          <label>Ngày Báo NCC Hủy</label>
          <date-picker v-model="phoneNumberDetail.provider_cancel_date" valueType="format" :disabled="isTechnicalStaff"></date-picker>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12">
          <label>KH sử dụng</label>
          <multiselect v-model="phoneNumberDetail.phone_number_client" :options="phoneClientList" :multiple="false"
                       :close-on-select="true"
                       placeholder="Vui lòng chọn" label="text" track-by="value" :disabled="isTechnicalStaff"></multiselect>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12">
          <label>Brand</label>
          <input type="text" class="form-control" v-model="phoneNumberDetail.brand" placeholder="Nhập brand..." :disabled="isTechnicalStaff"/>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12">
          <label>Thiết bị</label>
          <input type="text" class="form-control" v-model="phoneNumberDetail.device" placeholder="Nhập thiết bị..." :disabled="isTechnicalStaff"/>
        </div>
        <div class="form-group col-md-3 col-sm-6 col-xs-12">
          <label>Port</label>
          <input type="number" class="form-control" v-model="phoneNumberDetail.port" placeholder="Nhập port..." :disabled="isTechnicalStaff"/>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 h-100">
        <h5 class="col-md-12 col-sm-12 col-xs-12">THÔNG TIN PHÍ</h5>
        <div class="form-group col-md-6 col-sm-6 col-xs-12">
          <label>Phí khởi tạo></label>
          <div class="d-flex justify-content-between">
            <currency-input v-model.number="phoneNumberDetail.init_fee" :disabled="isTechnicalStaff"/>
            <date-picker v-model="phoneNumberDetail.init_payment_date" valueType="format"
                         placeholder="Ngày nhập phí" :disabled="isTechnicalStaff"></date-picker>
          </div>
        </div>
        <div class="form-group col-md-6 col-sm-6 col-xs-12">
          <label>Phí duy trì</label>
          <div class="d-flex justify-content-between">
            <currency-input v-model.number="phoneNumberDetail.operate_fee" :disabled="isTechnicalStaff"/>
            <date-picker v-model="phoneNumberDetail.operate_payment_date" valueType="format"
                         placeholder="Ngày nhập phí" :disabled="isTechnicalStaff"></date-picker>
          </div>
        </div>
        <div class="form-group col-md-6 col-sm-6 col-xs-12">
          <label>Phí mở</label>
          <div class="d-flex justify-content-between">
            <currency-input v-model.number="phoneNumberDetail.open_fee" :disabled="isTechnicalStaff"/>
            <date-picker v-model="phoneNumberDetail.open_payment_date" valueType="format"
                         placeholder="Ngày nhập phí" :disabled="isTechnicalStaff"></date-picker>
          </div>
        </div>
        <div class="form-group col-md-6 col-sm-6 col-xs-12">
          <label>Phí khác</label>
          <div class="d-flex justify-content-between">
            <currency-input v-model.number="phoneNumberDetail.other_fee" :disabled="isTechnicalStaff"/>
            <date-picker v-model="phoneNumberDetail.other_payment_date" valueType="format"
                         placeholder="Ngày nhập phí" :disabled="isTechnicalStaff"></date-picker>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
          <label>Ghi chú</label>
          <textarea
            class="form-control"
            id="phoneNumerNote"
            v-model="phoneNumberDetail.note"
            rows="3"
            style="height: 71px!important;"
            :disabled="isTechnicalStaff"
          ></textarea>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <div class="form-group col-md-12 col-sm-12 col-xs-12">
          <div class="col-md-6 col-sm-6 col-xs-12" style="padding: 0">
            <label>Trạng thái khóa số</label>
            <table>
              <tr>
                <th></th>
                <th class="cell-status">Đã gửi nhà cung cấp</th>
                <th class="cell-status">Đã mở</th>
                <th class="cell-status">Nhà cung cấp báo sai</th>
              </tr>
              <tr v-for="(provider, i) in lockingStatusProviders" :key="provider.key">
                <td class="first-cell-status">{{ provider.key | capitalize }}</td>
                <td class="cell-status">
                  <b-form-checkbox
                    :id="'checkbox-sent_provider' + i"
                    v-model="provider.status"
                    :name="'checkbox-sent_provider' + i"
                    size="lg"
                    value="SENT_PROVIDER"
                    :disabled="isTechnicalStaff"
                  ></b-form-checkbox>
                </td>
                <td class="cell-status">
                  <b-form-checkbox
                    :id="'checkbox-opened' + i"
                    @change="onCheckUnlock($event, provider)"
                    v-model="provider.status"
                    :name="'checkbox-opened' + i"
                    size="lg"
                    :disabled="isTechnicalStaff"
                    value="OPENED"></b-form-checkbox>
                </td>
                <td class="cell-status">
                  <b-form-checkbox
                    :id="'checkbox-wrong_report' + i"
                    v-model="provider.status"
                    :name="'checkbox-wrong_report' + i"
                    size="lg"
                    :disabled="isTechnicalStaff"
                    value="WRONG_REPORT"></b-form-checkbox>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-6 col-sm-6 col-xs-12" style="padding-right: 0;">
            <label>Trạng thái sử dụng</label>
            <table>
              <tr>
                <th></th>
                <th class="cell-status">Mạng mở</th>
                <th class="cell-status">Mạng bị khóa</th>
                <th class="cell-status">Mạng đang sử dụng</th>
              </tr>
              <tr v-for="(provider, i) in usingStatusProviders" :key="provider.key">
                <td class="first-cell-status">{{ provider.key | capitalize }}</td>
                <td class="cell-status">
                  <b-form-checkbox
                    :id="'checkbox-unlock' + i"
                    v-model="provider.status"
                    :name="'checkbox-unlock' + i"
                    size="lg"
                    value="OPEN"></b-form-checkbox>
                </td>
                <td class="cell-status">
                  <b-form-checkbox
                    :id="'checkbox-lock' + i"
                    @change="onCheckLock($event, provider)"
                    v-model="provider.status"
                    :name="'checkbox-lock' + i"
                    size="lg"
                    value="LOCK"></b-form-checkbox>
                </td>
                <td class="cell-status">
                  <b-form-checkbox
                    :id="'checkbox-use' + i"
                    @change="onCheckUse($event, provider)"
                    v-model="provider.status"
                    :name="'checkbox-use' + i"
                    size="lg"
                    value="USING"></b-form-checkbox>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
        <div class="pull-left">
          <b-button variant="danger" @click="save" :disabled="!isEditable || saving || loading">
            <span class="fa fa-floppy-o" aria-hidden="true"></span> Lưu thông tin số
          </b-button>
          <b-button variant="warning" @click="showPhoneNumberActivity" :disabled="!isEditable || saving || loading">Lịch
            sử thay đổi
          </b-button>
          <b-button variant="primary" @click="showPhoneNumberLockHistory" :disabled="!isEditable || saving || loading">
            Lịch
            sử khóa mạng
          </b-button>
          <b-button variant="secondary" @click="back"><span class="glyphicon glyphicon-remove"
                                                            aria-hidden="true"></span> Đóng
          </b-button>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 h-100">
        <PhoneNumberMonthlyFee :id="id"></PhoneNumberMonthlyFee>
      </div>
    </div>

    <b-modal size='lg' id="phoneNumberActivityModal" hide-footer title="Lịch sử thay đổi">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <PhoneNumberActivity :id="id" :legal-list="legalList" :main-phone-number-list="mainPhoneNumberList"
                             :phone-number-client-list="phoneClientList" :phone-number-status-list="phoneStatusList"
                             :provider-list="providerList"></PhoneNumberActivity>
      </div>
    </b-modal>
    <b-modal size='lg' id="phoneNumberLockHistoryModal" hide-footer title="Lịch sử khóa mạng">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <PhoneNumberLockHistory :id="id" :phone-number-detail="phoneNumberDetail"></PhoneNumberLockHistory>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Utils from '../../common/utils'
import {mapGetters} from 'vuex'
import {LOCAL_STORAGE_KEY, PERMISSION_KEY, STATUS_PHONE_NUMBER} from '../../common/constant'
import DatePicker from 'vue2-datepicker'
import Multiselect from '../../lib/vue-multiple-select/Multiselect.vue'
import DataHistory from '../order_management/DataHistory.vue'
import PhoneNumberAPI from '../../api/phoneNumberApi'
import {isNumber} from 'lodash'
import moment from 'moment/moment'
import PhoneNumberMonthlyFee from './PhoneNumberMonthlyFee.vue'
import PhoneNumberActivity from './PhoneNumberActivity.vue'
import PhoneNumberLockHistory from './PhoneNumberLockHistory.vue'

export default {
  name: 'PhoneNumberDetail',
  components: {
    PhoneNumberActivity,
    DataHistory,
    DatePicker,
    Multiselect,
    PhoneNumberMonthlyFee,
    PhoneNumberLockHistory
  },
  props: {
    id: {
      type: Number,
      required: false
    },
    hideModal: {
      type: Function
    },
    moveStatusList: {
      type: Array,
      required: true
    },
    isTechnicalStaff: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      selectedId: null,
      company: null,
      isCreateNew: false,
      isEditable: false,
      internalMoveStatusList: [],
      phoneNumberDetail: {
        company_id: null,
        phone_number: null,
        main_phone_number_id: null,
        provider_id: null,
        legal_id: null,
        phone_number_client_id: null,
        phone_number_status_id: null,
        pickup_date: null,
        client_use_date: null,
        provider_cancel_date: null,
        brand: '',
        device: '',
        port: null,
        lock_provider: '',
        unlock_provider: '',
        lock_count: 0,
        phone_number_avg_age: 0,
        cancel_date: null,
        init_fee: 0,
        init_payment_date: moment().format('yyyy-MM-DD'),
        operate_fee: 0,
        operate_payment_date: moment().format('yyyy-MM-DD'),
        open_fee: 0,
        open_payment_date: moment().format('yyyy-MM-DD'),
        other_fee: 0,
        other_payment_date: moment().format('yyyy-MM-DD'),
        note: ''
      },
      usingStatusProviders: [
        {key: 'viettel', status: ''},
        {key: 'mobifone', status: ''},
        {key: 'vinaphone', status: ''},
        {key: 'other', status: ''}
      ],
      lockingStatusProviders: [
        {key: 'viettel', status: ''},
        {key: 'mobifone', status: ''},
        {key: 'vinaphone', status: ''},
        {key: 'other', status: ''}
      ],
      usingStatusInitialized: false,
      providerList: [],
      phoneStatusList: [],
      phoneClientList: [],
      mainPhoneNumberList: [],
      legalList: [],
      monthlyFees: [
        {
          created_date: new Date(),
          on_net_fee: 10000,
          off_net_fee: 20000,
          billing_month: '02/2024'
        }
      ],
      click: false,
      saving: false,
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    errorPhoneNumber () {
      return this.isEmpty(this.phoneNumberDetail.phone_number)
    },
    errorPhoneNumberStatus () {
      return this.click && !this.phoneNumberDetail.phone_number_status
    },
    errorPhoneNumberBrand () {
      return this.click && !this.phoneNumberDetail.brand
    },
    errorPhoneNumberCustomer () {
      return this.click && !this.phoneNumberDetail.phone_number_client
    },
    errorPhoneNumberLegal () {
      return this.click && !this.phoneNumberDetail.legal
    },
    errorPhoneNumberProvider () {
      return this.click && !this.phoneNumberDetail.provider
    },
    errorPhoneNumberPickedDate () {
      return this.click && !this.phoneNumberDetail.pickup_date
    },
    errorPhoneNumberMain () {
      return this.click && !this.phoneNumberDetail.main_phone_number
    },
    errorInitFee () {
      return this.click && (!isNumber(this.phoneNumberDetail.init_fee) || !this.phoneNumberDetail.init_payment_date)
    },
    errorOperateFee () {
      return this.click && (!isNumber(this.phoneNumberDetail.operate_fee) || !this.phoneNumberDetail.operate_payment_date)
    },
    errorOpenFee () {
      return this.click && (!isNumber(this.phoneNumberDetail.open_fee) || !this.phoneNumberDetail.open_payment_date)
    },
    errorOtherFee () {
      return this.click && (!isNumber(this.phoneNumberDetail.other_fee) || !this.phoneNumberDetail.other_payment_date)
    },
    errorNote () {
      return this.click && !this.phoneNumberDetail.note
    }
  },
  mounted () {
    this.selectedId = this.id
    this.isCreateNew = this.id == null
    this.internalMoveStatusList = [...this.moveStatusList]
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    this.getPhoneNumberDetail()
    this.isEditable = this.hasEditPermission()
    this.initFilter()
  },
  watch: {
    usingStatusProviders: {
      handler: function () {
        if (this.usingStatusInitialized) {
          this.onChangeUsingStatus()
        } else {
          this.usingStatusInitialized = true
        }
      },
      deep: true
    }
  },
  methods: {
    onCheckUnlock (event, key) {
      if (event) {
        let retest = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.RETEST)
        if (retest !== undefined) {
          this.phoneNumberDetail.phone_number_status = retest
        }
      }
    },
    onCheckLock (event, key) {
      if (event) {
        let monitoring = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.MONITORING)
        if (monitoring !== undefined) {
          this.phoneNumberDetail.phone_number_status = monitoring
        }
      }
    },
    onCheckUse (event, key) {
      if (event) {
        if (this.phoneNumberDetail.phone_number_status.text === STATUS_PHONE_NUMBER.QUALIFIED || this.phoneNumberDetail.phone_number_status.text === STATUS_PHONE_NUMBER.AVAILABLE) {
          let using = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.USING)
          if (using !== undefined) {
            this.phoneNumberDetail.phone_number_status = using
          }
        }
      }
    },
    onChangeUsingStatus () {
      const statusName = this.phoneStatusList.find(item => item.value === this.phoneNumberDetail.phone_number_status.value)
      if (statusName && statusName !== STATUS_PHONE_NUMBER.NEW && statusName !== STATUS_PHONE_NUMBER.MONITORING && statusName !== STATUS_PHONE_NUMBER.RETEST && statusName !== STATUS_PHONE_NUMBER.WAIT_CANCEL && statusName !== STATUS_PHONE_NUMBER.NOT_USE) {
        let using = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.USING)
        let available = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.AVAILABLE)
        let locked = this.phoneStatusList.find(item => item.text === STATUS_PHONE_NUMBER.LOCKED)

        const findUsing = this.usingStatusProviders.find(item => item.status === 'USING')
        if (findUsing && using) {
          this.phoneNumberDetail.phone_number_status = using
          return
        }

        const findNotLock = this.usingStatusProviders.find(item => item.status !== 'LOCK')
        if (findNotLock === undefined) {
          console.log(locked)
          this.phoneNumberDetail.phone_number_status = locked
          return
        }
        this.phoneNumberDetail.phone_number_status = available
      }
    },
    buildRequestProvider () {
      let status = {}
      this.usingStatusProviders.forEach(provider => { status[provider.key] = provider.status ? provider.status : 'IN_QUEUE' })
      return status
    },
    buildRequestLockingProvider () {
      let status = {}
      this.lockingStatusProviders.forEach(provider => { status[provider.key] = provider.status ? provider.status : 'AVAILABLE' })
      return status
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_MANAGER) || this.editPermission.includes(PERMISSION_KEY.PHONE_NUMBER_TECHNICAL)
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    validate () {
      return !this.errorOperateFee && !this.errorInitFee && !this.errorPhoneNumberMain &&
        !this.errorPhoneNumberPickedDate && !this.errorPhoneNumberProvider && !this.errorPhoneNumberProvider &&
        !this.errorPhoneNumberLegal && !this.errorPhoneNumberStatus && !this.errorPhoneNumber
    },
    save () {
      if (!this.id) {
        this.click = true
        this.saving = true
        this.loading = true
        if (!this.validate()) {
          this.saving = false
          this.loading = false
          return
        }
        this.phoneNumberDetail.company_id = this.company.id
        PhoneNumberAPI.create(this.buildDto()).then(res => {
          this.saving = false
          this.click = false
          this.loading = false
          Utils.successToast(this.$bvToast)
          this.buildDtoFromResponse(res.data.data)
        }).catch(() => {
          Utils.failedToast(this.$bvToast)
        })
      } else {
        this.click = true
        this.saving = true
        this.loading = true
        if (!this.validate()) {
          console.log('validate false')
          this.saving = false
          this.loading = false
          return
        }

        console.log('validate true')
        PhoneNumberAPI.update(this.buildDto()).then(res => {
          this.saving = false
          this.click = false
          this.loading = false
          Utils.successToast(this.$bvToast)
          this.buildDtoFromResponse(res.data.data)
        }).catch(() => {
          Utils.failedToast(this.$bvToast)
        })
      }
    },
    buildDtoFromResponse (phoneNumber) {
      this.phoneNumberDetail = phoneNumber
      this.id = phoneNumber.id
      const main = this.mainPhoneNumberList.find(item => item.value === phoneNumber.main_phone_number)
      if (main) {
        this.phoneNumberDetail.main_phone_number = {text: main.text, value: main.value}
      }
      const provider = this.providerList.find(item => item.value === phoneNumber.provider)
      if (provider) {
        this.phoneNumberDetail.provider = {text: provider.text, value: provider.value}
      }
      const legal = this.legalList.find(item => item.value === phoneNumber.legal)
      if (legal) {
        this.phoneNumberDetail.legal = {text: legal.text, value: legal.value}
      }
      const client = this.phoneClientList.find(item => item.value === phoneNumber.phone_number_client)
      if (client) {
        this.phoneNumberDetail.phone_number_client = {text: client.text, value: client.value}
      }
      const status = this.phoneNumberDetail.phone_number_status_id = this.phoneStatusList.find(item => item.value === phoneNumber.phone_number_status)
      if (status) {
        this.phoneNumberDetail.phone_number_status = {text: status.text, value: status.value}
        let alreadyExisted = this.moveStatusList.find(item => item.value === status.value)
        if (alreadyExisted === undefined) {
          this.internalMoveStatusList.push(this.phoneNumberDetail.phone_number_status)
        }
      }
      this.usingStatusProviders = [
        {
          key: 'viettel',
          status: this.phoneNumberDetail.viettel_using_status
        },
        {
          key: 'mobifone',
          status: this.phoneNumberDetail.mobifone_using_status
        },
        {
          key: 'vinaphone',
          status: this.phoneNumberDetail.vinaphone_using_status
        },
        {
          key: 'other',
          status: this.phoneNumberDetail.other_using_status
        }
      ]

      this.lockingStatusProviders = [
        {
          key: 'viettel',
          status: this.phoneNumberDetail.viettel_unlocking_status
        },
        {
          key: 'mobifone',
          status: this.phoneNumberDetail.mobifone_unlocking_status
        },
        {
          key: 'vinaphone',
          status: this.phoneNumberDetail.vinaphone_unlocking_status
        },
        {
          key: 'other',
          status: this.phoneNumberDetail.other_unlocking_status
        }
      ]
    },
    buildDto () {
      let usingStatusProviders = this.buildRequestProvider()
      let lockingStatus = this.buildRequestLockingProvider()
      return {
        id: this.phoneNumberDetail.id,
        company_id: this.company.id,
        phone_number: this.phoneNumberDetail.phone_number,
        main_phone_number_id: this.phoneNumberDetail.main_phone_number.value,
        provider_id: this.phoneNumberDetail.provider.value,
        legal_id: this.phoneNumberDetail.legal.value,
        phone_number_client_id: this.phoneNumberDetail.phone_number_client ? this.phoneNumberDetail.phone_number_client.value : null,
        phone_number_status_id: this.phoneNumberDetail.phone_number_status.value,
        pickup_date: this.phoneNumberDetail.pickup_date,
        brand: this.phoneNumberDetail.brand,
        lock_provider: this.phoneNumberDetail.lock_provider,
        lock_count: this.phoneNumberDetail.lock_count,
        phone_number_avg_age: this.phoneNumberDetail.phone_number_avg_age,
        cancel_date: this.phoneNumberDetail.cancel_date,
        init_fee: this.phoneNumberDetail.init_fee,
        operate_fee: this.phoneNumberDetail.operate_fee,
        open_fee: this.phoneNumberDetail.open_fee,
        other_fee: this.phoneNumberDetail.other_fee,
        note: this.phoneNumberDetail.note,
        other_payment_date: this.phoneNumberDetail.other_payment_date,
        open_payment_date: this.phoneNumberDetail.open_payment_date,
        operate_payment_date: this.phoneNumberDetail.operate_payment_date,
        init_payment_date: this.phoneNumberDetail.init_payment_date,
        client_use_date: this.phoneNumberDetail.client_use_date,
        provider_cancel_date: this.phoneNumberDetail.provider_cancel_date,
        viettel_using_status: usingStatusProviders.viettel,
        mobifone_using_status: usingStatusProviders.mobifone,
        vinaphone_using_status: usingStatusProviders.vinaphone,
        other_using_status: usingStatusProviders.other,
        viettel_unlocking_status: lockingStatus.viettel,
        mobifone_unlocking_status: lockingStatus.mobifone,
        vinaphone_unlocking_status: lockingStatus.vinaphone,
        other_unlocking_status: lockingStatus.other,
        device: this.phoneNumberDetail.device,
        port: this.phoneNumberDetail.port
      }
    },
    showPhoneNumberActivity () {
      this.$bvModal.show('phoneNumberActivityModal')
    },
    showPhoneNumberLockHistory () {
      this.$bvModal.show('phoneNumberLockHistoryModal')
    },
    back () {
      this.hideModal('phoneNumberDetail')
    },
    initFilter () {
      const legalList = localStorage.getItem(LOCAL_STORAGE_KEY.LEGAL_LIST)
      if (legalList) {
        this.legalList = JSON.parse(legalList)
      }
      const mainPhoneNumberList = localStorage.getItem(LOCAL_STORAGE_KEY.MAIN_PHONE_NUMBER_LIST)
      if (mainPhoneNumberList) {
        this.mainPhoneNumberList = JSON.parse(mainPhoneNumberList)
      }
      const phoneClientList = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_NUMBER_CLIENT)
      if (phoneClientList) {
        this.phoneClientList = JSON.parse(phoneClientList)
      }
      const phoneStatusList = localStorage.getItem(LOCAL_STORAGE_KEY.PHONE_STATUS_LIST)
      if (phoneStatusList) {
        this.phoneStatusList = JSON.parse(phoneStatusList)
      }
      const providerList = localStorage.getItem(LOCAL_STORAGE_KEY.PROVIDER_LIST)
      if (providerList) {
        this.providerList = JSON.parse(providerList)
      }
    },
    async getPhoneNumberDetail () {
      if (this.id) {
        this.loading = true
        PhoneNumberAPI.get(this.id).then(res => {
          this.loading = false
          this.buildDtoFromResponse(res.data.data)
        }).catch(() => {
          Utils.failedToast(this.$bvToast)
        })
      }
    },
    onStatusSelect (status) {
      if (status.text === 'Đã gửi nhà cung cấp hủy') {
        this.phoneNumberDetail.provider_cancel_date = moment().format('yyyy-MM-DD')
      }
    }
  },
}
</script>

<style scoped>
table {
  width: 100%;
}

table, td, th, tr {
  border: 1px solid lightgray;
}
.first-cell-status {
  padding: 2px 10px;
}
.cell-status {
  width: 25%;
  text-align: center;
  padding: 5px 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/PhoneNumberDetail.vue